import { useEffect } from "react";
import { getMessaging, onMessage, isSupported } from "firebase/messaging";
import app from "../firebase";
import { showDesktopNotification } from "utils/firebaseMessaging";

/**
 * Subscribes to FCM messages while the tab is focused and shows a desktop toast.
 *
 * @param {(payload: import("firebase/messaging").MessagePayload) => void} [onForegroundMessage]
 */
export const useForegroundNotifications = (onForegroundMessage) => {
  useEffect(() => {
    let unsubscribe = () => {};
    let cancelled = false;

    const subscribe = async () => {
      const supported = await isSupported();
      if (!supported || cancelled) {
        return;
      }

      const messaging = getMessaging(app);
      unsubscribe = onMessage(messaging, (payload) => {
        if (!payload) {
          return;
        }
        onForegroundMessage?.(payload);
        showDesktopNotification(payload);
      });
    };

    subscribe();

    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, [onForegroundMessage]);
};
